<template>
  <div class="send-cv-mode-selector">
    <div class="mode-selector-header">
      <h4 class="mode-title">מצב שליחת קורות חיים</h4>
    </div>
    <!--
      `super_lite` is deliberately NOT offered here (UX ruling 1 / R-7):
      CVModalForm cannot send it and Phase 1 adds no form-switch action, so the
      route to super lite is the mode-selection modal. The absence is silent by
      design — the support answer lives in UX_SPEC §8.3, not on screen.

      Binding: BaseRadio takes `:value` + `:modelValue` + `@input` (the
      BaseRadioGroup pattern). `v-model` + a static `value` is broken — Vue 2's
      transformModel writes `value` into the component's props and the static
      attribute is overwritten, so every radio reported the same value.
    -->
    <div class="mode-options">
      <BaseRadio
        name="send_cv_mode"
        :value="'normal'"
        :modelValue="selectedMode"
        label="רגיל"
        :labelClass="getLabelClass('normal')"
        :inputClass="'mode-radio'"
        @input="onModeChange"
      />
      <BaseRadio
        name="send_cv_mode"
        :value="'lite'"
        :modelValue="selectedMode"
        label="לייט"
        :labelClass="getLabelClass('lite')"
        :inputClass="'mode-radio'"
        @input="onModeChange"
      />
    </div>
    <div class="mode-description">
      <span v-if="selectedMode === 'normal'" class="description-text">
        מצב רגיל - שליחת קורות חיים מלאים עם כל הפרטים
      </span>
      <span v-else-if="selectedMode === 'lite'" class="description-text">
        מצב לייט - שליחת קורות חיים מקוצרים
      </span>
    </div>
  </div>
</template>

<script>
import BaseRadio from '@/components/BaseRadio.vue'

export default {
  name: 'SendCvModeRadioSelector',
  components: {
    BaseRadio
  },
  props: {
    value: {
      type: String,
      default: 'normal'
    }
  },
  data () {
    return {
      selectedMode: this.value
    }
  },
  watch: {
    value (newVal) {
      this.selectedMode = newVal
    }
  },
  methods: {
    onModeChange (value) {
      this.selectedMode = value
      this.$emit('input', value)
      this.$emit('change', value)
    },
    getLabelClass (mode) {
      return this.selectedMode === mode ? 'mode-label active' : 'mode-label'
    }
  }
}
</script>

<style scoped>
.send-cv-mode-selector {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  direction: rtl;
}

.mode-selector-header {
  margin-bottom: 12px;
}

.mode-title {
  font-size: 16px;
  font-weight: bold;
  color: #495057;
  margin: 0;
  text-align: center;
}

.mode-options {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  gap: 20px;
}

/* `labelClass` / `inputClass` land on elements INSIDE BaseRadio, which scoped
   CSS cannot reach — the deep combinator is required for these rules to apply
   at all. */
.mode-options >>> .mode-label {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 96px;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
}

.mode-options >>> .mode-label:hover {
  background-color: #e3f2fd;
  border-color: #1976d2;
}

/* The native radio is visually inside the label, so the ring has to come from
   the label itself or the keyboard focus is invisible. */
.mode-options >>> .mode-label:focus-within {
  outline: 2px solid #3273dc;
  outline-offset: 2px;
}

.mode-options >>> .mode-radio {
  margin-left: 8px;
  accent-color: #1976d2;
}

.mode-description {
  text-align: center;
  margin-top: 8px;
}

.description-text {
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}

/* Active state for selected radio. #2196f3 gave 3.13:1 against white — below
   AA; #1976d2 is 4.60:1. */
.mode-options >>> .mode-label.active {
  background-color: #1976d2;
  color: white;
  border-color: #1976d2;
}
</style>
